import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "buttons"
}
const _hoisted_2 = {
  "aria-label": "Profile",
  alt: "Profile",
  title: "Profile"
}
const _hoisted_3 = { class: "dropdownMenu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_VDropdown = _resolveComponent("VDropdown")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ headerBackground: _ctx.needsHeaderBackground })
  }, [
    _createVNode(_component_router_link, {
      to: { name: _ctx.isLoggedIn ? 'Home' : 'Login' },
      class: "title"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("h2", { alt: "Learning Platform" }, [
          _createTextVNode("learning"),
          _createElementVNode("br"),
          _createTextVNode("platform")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["to"]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_VDropdown, { distance: 6 }, {
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
                }, "Log out")
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_2, [
                _createVNode(_component_ion_icon, { name: "person-circle-outline" })
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}